import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  mobileMenuState = false;

  constructor() { }

  ngOnInit(): void {
  }

  showHideNavbar(){
    const element = document.getElementById('navbarSupportedContent');
    
    if (element && this.mobileMenuState == false){
      
      element.classList.add('show');
      //element.setAttribute("style", "background-color:#FFFFFF;");
      this.mobileMenuState = true;
    }
  else if (element && this.mobileMenuState == true)
     {

      element.classList.remove('show');  
      this.mobileMenuState = false;  
      }
    
    
  }

}
